import { FC } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Stack, Typography } from 'styles';
import { useTranslation } from 'utils/translations';
import { monthDiff } from 'utils/utils';

const NewClaimErrorMessages: FC<{
	doctorType: string;
	prescriptionDate: Date | null;
	isRxCheckAvoided: boolean;
}> = ({ doctorType, prescriptionDate, isRxCheckAvoided }) => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { member } = useSelector((store: RootState) => store.member);

	const today = new Date();

	const isPrescriptionValid =
		!member?.rxChangeConfiguration.prescriptionWarningControl ||
		prescriptionDate === null
			? true
			: member?.rxChangeConfiguration.validityPrescriptionMonth !== null &&
				today >= prescriptionDate &&
				monthDiff(prescriptionDate, today) <
					member?.rxChangeConfiguration.validityPrescriptionMonth;

	const isDoctorTypeAllowed =
		!member?.rxChangeConfiguration.doctorWarningControl || doctorType === 'reset'
			? true
			: member?.rxChangeConfiguration.allowedDoctors
					.map(el => el.name)
					.includes(doctorType);

	return (
		<Stack>
			{isRxCheckAvoided && (
				<Stack>
					<Typography variant={'italic'}>
						{tClientLabels('newClaim.errorMessage.rxChangeAttestation')}
					</Typography>
				</Stack>
			)}

			{!isDoctorTypeAllowed || !isPrescriptionValid ? (
				<Stack>
					{!isDoctorTypeAllowed && !isPrescriptionValid ? (
						<Typography variant={'italic'}>
							{tClientLabels('newClaim.errorMessage.bothErrors')}
						</Typography>
					) : (
						<></>
					)}
					<ul
						style={
							!isDoctorTypeAllowed && !isPrescriptionValid
								? { margin: 0, paddingLeft: '24px' }
								: {
										listStyleType: 'none',
										margin: 0,
										padding: 0,
									}
						}
					>
						{isDoctorTypeAllowed ? (
							<></>
						) : (
							<li style={{ fontSize: '14px' }}>
								<Typography variant={'italic'}>
									{tClientLabels('newClaim.errorMessage.doctorType')}
								</Typography>
							</li>
						)}
						{!isPrescriptionValid ? (
							<li style={{ fontSize: '14px' }}>
								<Typography variant={'italic'}>
									{tClientLabels('newClaim.errorMessage.prescription', {
										prescriptionValidity:
											member?.rxChangeConfiguration.validityPrescriptionMonth,
									})}
								</Typography>
							</li>
						) : (
							<></>
						)}
					</ul>
					<Typography variant={'italic'}>
						{tClientLabels('newClaim.errorMessage.mayProceed')}
					</Typography>
				</Stack>
			) : (
				<></>
			)}
		</Stack>
	);
};

export default NewClaimErrorMessages;
